var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoice-summary" },
    [
      _vm.isInvoiceValueVisible
        ? [
            _c(
              "span",
              { staticClass: "invoice-value", style: _vm.statusStyle },
              [
                _c("RenderMoneyColumnValue", {
                  attrs: {
                    value: _vm.invoiceValue || 0,
                    "max-fraction-digits": 0
                  }
                }),
                _vm._v("\n      R$\n    ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.showSeparatorAfterInvoiceValue
              ? _c("span", { staticClass: "separator" }, [_vm._v("|")])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isQtyInvoiceVisible
        ? [
            _c(
              "span",
              { staticClass: "qty-invoices", style: _vm.statusStyle },
              [_vm._v("\n      " + _vm._s(_vm.qtyInvoices) + " #\n    ")]
            ),
            _vm._v(" "),
            _vm.showSeparatorAfterQtyInvoice
              ? _c("span", { staticClass: "separator" }, [_vm._v("|")])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isAverageTicketVisible
        ? [
            _c(
              "span",
              { staticClass: "average-ticket", style: _vm.statusStyle },
              [
                _c("RenderMoneyColumnValue", {
                  style: _vm.statusStyle,
                  attrs: { value: _vm.averageTicket, "max-fraction-digits": 0 }
                }),
                _vm._v("\n      TM\n    ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.showSeparatorAfterAverageTicket
              ? _c("span", { staticClass: "separator" }, [_vm._v("|")])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isOverallPercentageVisible
        ? [
            _c(
              "span",
              { staticClass: "overall-percentage", style: _vm.statusStyle },
              [
                _c("RenderPercentageColumnValue", {
                  attrs: { value: _vm.overallPercentageInvoiceValue }
                }),
                _vm._v("\n      V\n    ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.showSeparatorAfterOverallPercentage
              ? _c("span", { staticClass: "separator" }, [_vm._v("|")])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSubTotalVisible
        ? [
            _c(
              "span",
              { staticClass: "subtotal-percentage", style: _vm.statusStyle },
              [
                _c("RenderPercentageColumnValue", {
                  attrs: { value: _vm.subTotalPercentageInvoiceValue }
                }),
                _vm._v("\n      H\n    ")
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }